import { render, staticRenderFns } from "./userGroupDetail.vue?vue&type=template&id=51b6b6d8&scoped=true&"
import script from "./userGroupDetail.vue?vue&type=script&lang=js&"
export * from "./userGroupDetail.vue?vue&type=script&lang=js&"
import style0 from "./userGroupDetail.vue?vue&type=style&index=0&id=51b6b6d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b6b6d8",
  null
  
)

export default component.exports